import React, { useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

export const query = graphql`
  query {
    allNodeCatalogues(
      filter: {status: {eq: true}}
      sort: {fields: changed, order: DESC}
    ) {
      edges {
        node {
          title
          relationships {
            field_catalogue_media {
              relationships {
                field_media_image_2 {
                  gatsbyImage(height: 250, width: 320, quality: 100)
                }
              }
            }
            field_catalogue_file {
              filename
              uri {
                url
              }
            }
          }
        }
      }
    }
  }
`

const format = ({ edges }) => {
  return edges.map(({ node }) => {
    const { field_catalogue_file, field_catalogue_media } = node.relationships

    return {
      title: node.title,
      path: field_catalogue_file ? field_catalogue_file.uri.url : null,
      content: <>
        {field_catalogue_media && field_catalogue_media.relationships.field_media_image_2 && (
          <GatsbyImage image={getImage(field_catalogue_media.relationships.field_media_image_2)} alt={node.title} />
        )}
        <h3 className="mt-3">{node.title}</h3>
      </>
    }
  })
}

export const useCatalogues = () => {
  const { allNodeCatalogues } = useStaticQuery(query)
  return useMemo(() => format(allNodeCatalogues), [allNodeCatalogues])
}